import { render, staticRenderFns } from "./IconSvgInfo.vue?vue&type=template&id=20415c08&scoped=true&"
import script from "./IconSvgInfo.vue?vue&type=script&lang=js&"
export * from "./IconSvgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20415c08",
  null
  
)

export default component.exports